module.exports = __webpack_public_path__ + "images/home/boutonPixel.d29c15dd.svg";